module.exports = __webpack_public_path__ + "img/invitation -card.c366b107.jpg";